import script from "./CapitalList.vue?vue&type=script&setup=true&lang=js"
export * from "./CapitalList.vue?vue&type=script&setup=true&lang=js"

import "./CapitalList.vue?vue&type=style&index=0&id=5eec23e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eec23e0"]])

export default __exports__